import React from 'react';

export function Progress({ value, className }) {
  return <div className={`bg-blue-200 h-2 ${className}`} style={{ width: `${value}%` }} />;
}